import { render, staticRenderFns } from "./OrderAdmittanceReceptionImages.vue?vue&type=template&id=424b0772&"
import script from "./OrderAdmittanceReceptionImages.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceReceptionImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports